import React, { useState, useEffect, useContext } from "react";
import { dataContext, SERVER_HOST } from "../utils/constants";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SalesReport from "./dashboard-items/diSalesReport";
import FiscalReport from "./dashboard-items/diFiscalReport";
import EfficiencyStatistics from "./dashboard-items/diEfficiencyStatistics";
import CashBalances from "./dashboard-items/diCashBalances";
import SuppliersDebt from "./dashboard-items/diSuppliersDebt";
import PaymentTypes from "./dashboard-items/diPaymentTypes";
import PeakHours from "./dashboard-items/diPeakHours";
import PopularMenu from "./dashboard-items/diPopularMenu";
import StopList from "./dashboard-items/diStopList";
// import LossSoldGoods from "./dashboard-items/diLossSoldGoods";

export default function Dashboard() {
    const [isDataUpdating, setDataUpdating] = useState(false);
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const context = useContext(dataContext);
    const getSettings = context.getSettings;
    const setSettings = context.setSettings;
    const userRights = context.user.userRights;
    const isAdmin = context.user.isAdmin;

    const defaultItems = {
        salesReport: { show: true, label: "Статистика продажів" },
        fiscalReport: { show: true, label: "Офіційні продажі" },
        efficiencyStatistics: { show: true, label: "Статистика ефективності" },
        cashBalances: { show: true, label: "Залишки коштів" },
        suppliersDebt: { show: true, label: "Борг постачальникам" },
        paymentTypes: { show: true, label: "Види оплати" },
        peakHours: { show: true, label: "Пікові години" },
        popularMenu: { show: true, label: "Популярні страви" },
        stopList: { show: true, label: "Стоп-лист" },
        // lossSoldGoods: { show: true, label: "Продажі в збиток" },
    };

    const [visibleItems, setVisibleItems] = useState(() => {
        const userSettings = getSettings();
        const storedItems = userSettings.shef
            ? userSettings.shef.dashboardVisibleItems
            : null;
        return storedItems ? storedItems : defaultItems;
    });

    useEffect(() => {
        const userSettings = getSettings();
        setSettings({
            ...userSettings,
            shef: { ...userSettings.shef, dashboardVisibleItems: visibleItems },
        });
        // eslint-disable-next-line
    }, [visibleItems]);

    useEffect(() => {
        setDataUpdating(false);
    }, [isDataUpdating]);

    const handleDataUpdate = () => {
        setSidebarOpen(false);
        setDataUpdating(true);
    };

    const handleLogout = async () => {
        try {
            await fetch(SERVER_HOST, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ action: "logout" }),
            });
            window.location.reload();
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    return (
        <>
            <Header toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onLogout={handleLogout}
                visibleItems={visibleItems}
                setVisibleItems={setVisibleItems}
                handleDataUpdate={handleDataUpdate}
                userRights={userRights}
                isAdmin={isAdmin}
            />
            {!isDataUpdating && (
                <div className="container dashboard--container pb-2">
                    <div className="row d-flex justify-content-around">
                        <div className="col col-12 col-md-11 col-lg-9 col-xl-8 col-xxl-7 row justify-content-center m-0 p-0">
                            <div style={{ marginTop: "40px" }}></div>
                            {(isAdmin === 1 ||
                                userRights.urSalesReport === 1) &&
                                visibleItems.salesReport.show && (
                                    <SalesReport />
                                )}
                            {(isAdmin === 1 ||
                                userRights.urFiscalReport === 1) &&
                                visibleItems.fiscalReport.show && (
                                    <FiscalReport />
                                )}
                            {(isAdmin === 1 ||
                                userRights.urEfficiencyStatistics === 1) &&
                                visibleItems.efficiencyStatistics.show && (
                                    <EfficiencyStatistics />
                                )}
                            {(isAdmin === 1 ||
                                userRights.urCashBalances === 1) &&
                                visibleItems.cashBalances.show && (
                                    <CashBalances />
                                )}
                            {(isAdmin === 1 ||
                                userRights.urSuppliersDebt === 1) &&
                                visibleItems.suppliersDebt.show && (
                                    <SuppliersDebt />
                                )}
                            {(isAdmin === 1 ||
                                userRights.urPaymentTypes === 1) &&
                                visibleItems.paymentTypes.show && (
                                    <PaymentTypes />
                                )}
                            {(isAdmin === 1 || userRights.urPeakHours === 1) &&
                                visibleItems.peakHours.show && <PeakHours />}
                            {(isAdmin === 1 ||
                                userRights.urPopularMenu === 1) &&
                                visibleItems.popularMenu.show && (
                                    <PopularMenu />
                                )}
                            {(isAdmin === 1 || userRights.urStopList === 1) &&
                                visibleItems.stopList.show && <StopList />}
                            {/* {(isAdmin === 1 || userRights.urLossSoldGoods === 1) &&
                            visibleItems.lossSoldGoods.show && <LossSoldGoods />} */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
